import { gql } from '@apollo/client';

export type {
  GetPartnerOptions as IGetPartnerOptions,
  GetPartnerOptionsVariables as IGetPartnerOptionsVariables,
} from './__generated__/GetPartnerOptions';

export const GET_PARTNER_OPTIONS = gql`
  query GetPartnerOptions($partnershipType: String!) {
    partnersByType(type: $partnershipType) {
      displayName
      identifier
    }
  }
`;
